import { Component, OnInit } from '@angular/core';
import { ProductEditorComponent } from '../product-editor/product-editor.component';
import { LoadingComponent } from "../../../../node_modules/@digi-america/shared/src/lib/components/loading/loading.component";
import { AsyncPipe, NgIf } from '@angular/common';
import { ProductService } from '../../services/products.service';
import { Observable } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { Product } from '../../types/Product';
import { ToastService } from '@digi-america/shared';

@Component({
  selector: 'app-create-product',
  imports: [ProductEditorComponent, LoadingComponent, NgIf, AsyncPipe],
  templateUrl: './create-product.component.html',
  styleUrl: './create-product.component.scss',
})
export class CreateProductComponent implements OnInit {
  newProduct$!: Observable<Product>;

  constructor(private productService: ProductService, private route: ActivatedRoute, private router: Router, private toastSevice: ToastService) { }

  ngOnInit(): void {
    this.route.params.subscribe({
      next: (params) => {
        this.newProduct$ = this.productService.getNewProject(params['type']);
      }
    })
  }

  createProduct(product: Product) {
    this.productService.createProduct(product).subscribe({
      next: () => {
        this.router.navigate(["product-search", product.type]);
        this.toastSevice.success("Product Created!");
      },
      error: (problem) => {
        this.toastSevice.error(JSON.stringify(problem.error || problem.errors));
      }
    });
  }
}
